import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { focusAnswer } from 'app/modules/subject';
import { GoNextPageService } from 'app/modules/survey';
import { useCallback } from 'react';

/**
 * Since user may set answer very frequently, we need to add debounce on it.
 * If we want to cancel the latest invocation of `finish callback` but don't want
 * to execute it, just set disabled to true and invoke it again.
 */
export function useHandleAnswerFinish(
  engine: SurveyCakeLogicEngine,
  id: number
) {
  const goNextPage = GoNextPageService.useGoPage();

  return useCallback(
    (disabled: boolean = false) => {
      if (disabled) {
        return;
      }

      if (engine.isSingleSubjectPerPage()) {
        goNextPage();
      } else {
        const nextSubjectId = engine.isNextFocusable(id);

        if (nextSubjectId) {
          focusAnswer(nextSubjectId);
        }
      }
    },
    [engine, id, goNextPage]
  );
}
